import React, { ComponentProps, forwardRef } from 'react';
import { cx } from '@/utils';

interface iProps {
  nameButton: string | any;
  logo?: React.ReactNode;
  className?: string | undefined;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: 'button' | 'submit' | 'reset' | undefined;
  disabled?: boolean;
}

export const ButtonWithLogo = forwardRef<HTMLButtonElement, iProps>(
  (
    {
      nameButton,
      logo,
      className = 'border-primary bg-primary text-white hover:bg-primaryDark hover:border-primaryDark transition-all h-9 text-sm',
      onClick,
      type = 'button',
      disabled = false,
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        disabled={disabled}
        type={type}
        onClick={onClick}
        className={cx(
          'relative line-clamp-1 flex h-fit flex-row items-center gap-2 overflow-visible text-nowrap rounded-[100px] border-[2px] border-primary bg-primary px-3 py-2 text-left font-workSans text-white outline-none transition-all hover:border-primaryDark hover:bg-primaryDark disabled:pointer-events-none disabled:cursor-not-allowed disabled:border-transparent disabled:bg-[#F2F2F2]  disabled:text-[#919191] disabled:opacity-50',
          className
        )}
      >
        {logo}
        <span className="text-nowrap font-workSans text-sm font-medium">{nameButton}</span>
      </button>
    );
  }
);
ButtonWithLogo.displayName = 'ButtonWithLogo';

export type ButtonWithLogoProps = ComponentProps<typeof ButtonWithLogo>;
